<template>
    <div>

        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Student Marks Analysis </span>
        </v-row>
        <br />
                      <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
        <v-container>
                     <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
            <v-card outlined>
                <v-card-title class="heading">
                    <span class="headline">{{ formTitle }}</span>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text>
                    <v-row>
                         <v-col cols="4">
                             <label>Select Academic Year</label>
                                    <v-autocomplete dense 
                                      outlined v-model="ayselect" :items="aylist" item-text="ay" item-value="id" placeholder="Select Academic Year" return-object></v-autocomplete>
                   
                         </v-col>
                         <v-col cols="4">
                              <label>Select Semester</label>
                                  <v-autocomplete dense outlined v-model="semselect" :items="semlist" item-text="sem" item-value="id" placeholder="Select Semester" return-object @change="callme()"></v-autocomplete>
                           
                         </v-col>
                         <v-col cols="4">
                              <label>Select Exam</label>
                                  <v-autocomplete dense outlined v-model="qttypeselect" :items="exam" item-text="examname" item-value="id" placeholder="Select Exam" return-object></v-autocomplete>
                         
                         </v-col>
                    </v-row>
                     <v-row>
                         <v-col cols="4">
                              <label>Select Subject</label>
                              <v-autocomplete
                                    dense
                                    v-model="course"
                                    :items="course_list"
                                    item-text="course_name"
                                    item-value="crsid"
                                    placeholder="Select Subject"
                                    persistent-hint
                                    :disabled="editedIndex != -1"
                                    :filled="editedIndex==-1?false:true"
                                    return-object
                                    single-line
                                    outlined
                                ></v-autocomplete>
                                
                              </v-col>
                         <v-col cols="4">
                              <label>Select Department</label>
                              <v-autocomplete dense   outlined v-model="deptselect" :items="deptlist" item-text="name" item-value="id" placeholder="Select Department" return-object></v-autocomplete>
                          

                         </v-col>
                         <v-col cols="4">
                         </v-col>
                    </v-row>
                  
                    <div class="my-2">

                        <center>
                            <!-- <v-btn @click="questionbankentry" class="ma-2 button4">Fetch Data</v-btn> -->
                            <v-btn @click="unitwisedata" class="ma-2 button4">Unit Wise Data</v-btn>
                            <!-- <v-btn @click="studentquestionview(editedItem.course,qttypeselect)" class="ma-2 button2">Student Question View</v-btn> -->
                        </center>
                    </div>
                </v-card-text>
                             <download-excel class="mar" :data="studData" :fields="excelData"  worksheet="examtimetable_list" name="ExamTimeTableData.xls">
                                <v-btn color="success" dark class="mb-2">
                                    Export<v-icon dark>mdi-file-excel</v-icon>
                                </v-btn>
                            </download-excel>
         <v-simple-table class="table-data" v-if="studData!=null">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left"><center>Sr.No</center></th>
                                    <th class="text-left"><center>Reg No</center></th>
                                    <th class="text-left"><center>Student Name</center></th>
                                    <th class="text-left"><center>Seat No</center></th>
                                    <th class="text-left" v-for="item in unitName" :key="item"><center>{{item}}</center></th>
                                    <th class="text-left"><center>Total</center></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in studData" :key="item.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ item.registration_number }}</td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.seatno }}</td>
                                    <td v-for="(unit,index) in item.units" :key="index">{{ unit }}</td>
<td>{{ item.sum }}</td>

                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>

            </v-card>
        </v-container>

        <div>
    <h3 v-if="EM">{{ EM }}</h3>
    <bar-chart v-if="loaded" :chartdata="chartdata" :options="options"></bar-chart>
  </div>
   
    </div>
</template>
<script>
    // import DemoChart from './ChartingDemo'
    // import BarChart from './BarChart'
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        // name: 'charting-demo',
        // components: {
        //     BarChart
        // },
        
        data: () => ({
            studData:[],
            unitName:[],
            chartdata: Object,
            EM:"",
            options: Object,
            loaded: false,
            overlay: false,
            snackbar_msg: "",
            course:null,
            snackbar: false,
            color: "",
            iseditable: false,
            load: false,
            dialog: false,
            course_list: null,
            selected_course: "",
            qttypeselect: "",
            exam: null,
            semselect:null,
            semlist:null,
            aylist:null,
            ayselect:null,
            deptselect:null,
            deptlist:null,
            excelData:{
                'Reg No': 'registration_number',
                'Student Name': 'name',
                'Seat No':'seatno',

               
            },
            //crs_list: null,
            errorMsg: {
                course: false,
            },

            editedIndex: -1,
            editedItem: {
                id: 0,
                course: "",
            },
            defaultItem: {
                id: 0,
                course: "",
            },
        }),
       
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Student Mark Analysis" : "";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        mounted() {
            axios
                .post("/TestCode/viewExamCourse")
                .then((res) => {
                    if (res.data.msg == "200") {
                        console.log(res.data.course_list)
                        this.course_list = res.data.course_list;
                        this.deptlist = res.data.department_list;
                        this.aylist = res.data.academicyearlist;
                        this.semlist = res.data.semesterlist;
                        //this.qttypeselect = res.data.exams_current_id
                        this.load = true;
                    } else {
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                });
                //this.unitwisedata()
        },
        methods: {
            initializeErrorMsgFalse() {
                this.errorMsg.course = false;
            },
             showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        callme()
        {
                if(this.ayselect == null)
                {
                    this.showSnackbar("#b71c1c", "Please Select Academic Year!!!");
                    return
                }
                const data = {
                    ayid: this.ayselect.ayid,
                    semid: this.semselect.semid,
                };
                axios
                .post("/TestCode/findExam",data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.exam = res.data.exam_list;
                        this.load = true;
                    } else {
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                });
        },
            addQuestionBank(item, item1) {
                this.$router.push({ name: "add-que-Bank", params: { examtype_id: item1, courseId: item } });
            },
            unitwisedata()
            {
                this.overlay = true
              this.excelData = {
                'Reg No': 'registration_number',
                'Student Name': 'name',
                'Seat No':'seatno',
            }
                if(this.course == null)
                {
                        this.showSnackbar("#b71c1c", "Please Select Course!!!");
                        return
                }
                if(this.qttypeselect == "")
                {
                        this.showSnackbar("#b71c1c", "Please Select Exam!!!");
                        return
                }
                const data = {
                    crsid: this.course.crsid,
                    examid: this.qttypeselect.examid,
                    deptid: this.deptselect.deptid
                };
               
                axios
                .post("/TestCode/unitData",data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay =false
                        
                        this.studData =res.data.studList
                        this.unitName = res.data.unitName
for(let i=0;i<this.unitName.length;i++){
        this.excelData[this.unitName[i]] = this.unitName[i]
}
this.excelData.Total = 'sum'


                        console.log(res.data.templateinformation) 
                        this.chartdata = {
                            labels:['Unit1','Unit2','Unit3'],
                            datasets:[
                                {
                                    label:"# percentage ",
                                    data:[res.data.templateinformation.unit,res.data.templateinformation.ca],
                                    backgroundColor: '#f87979',
                                    borderWidth:1,
                                }
                            ]
                        } 
                        this.options = {
                                responsive: true,
                                maintainAspectRatio: false
                        }
                        this.loaded = true
                        this.showSnackbar("green", "Result File downloaded Sucessfully!!");
                    } else {
                    }
                })
                .catch((error) => {
                    // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                });

            },
            questionbankentry() {
                if(this.course == null)
                {
                        this.showSnackbar("#b71c1c", "Please Select Course!!!");
                        return
                }
                if(this.qttypeselect == "")
                {
                        this.showSnackbar("#b71c1c", "Please Select Exam!!!");
                        return
                }
                const data = {
                    crsid: this.course.crsid,
                    examid: this.qttypeselect.examid,
                    deptid: this.deptselect.deptid
                };
               
                axios
                .post("/TestCode/studetData",data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        alert('Result File downloaded Sucessfully,Please check your Downloads folder')
                        console.log("studetData---->"+res.data)
                        this.EM = res.data.EM;
                        this.load = true;
                    } else {
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                });
                // this.$store.commit("courseid", this.editedItem.course.id);
                // this.$store.commit("examid", this.qttypeselect);
                // console.log('setqbankquestype',this.qttypeselect)
                //this.$router.push("/add-question-Bank")
               
            },
            studentquestionview(item, item1) {
                if(this.editedItem.course == "")
                {
                        this.showSnackbar("#b71c1c", "Please Select Course!!!");
                        return
                }
                if(this.qttypeselect == "")
                {
                        this.showSnackbar("#b71c1c", "Please Select Exam!!!");
                        return
                }
                this.$router.push({ name: "stud-que-view", params: { examtype_id: item1, courseId: item , questypeid: this.qttypeselect} });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            isValidated() {
                if (this.editedItem.course) {
                    return true;
                } else {
                    if (!this.editedItem.course) {
                        this.errorMsg.course = true;
                    }

                    return false;
                }
            }, // .....end of isValidated()
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
</style>
